import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../configs/common.settings';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  constructor(private http: HttpClient) {}

  getCompanyById(id: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/company/get/${id}`);
  }

  getAllCompanies(): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/company/get-all`);
  }

  /** CR-57 — persist company-scoped job categories. */
  updateJobCategories(companyId: string, jobCategories: string[]): Observable<any> {
    return this.http.put(`${SETTINGS.BASE_API}/company/${companyId}/job-categories`, {
      jobCategories,
    });
  }

  /** Admin Common settings — invoice letterhead / payment details. */
  updateCommonDetails(companyId: string, payload: any): Observable<any> {
    return this.http.put(
      `${SETTINGS.BASE_API}/company/${companyId}/common-details`,
      payload
    );
  }
}
